export const filterText = (arrayValues: Array<string>, compare: string): boolean => {
  const normalizedValue = removeDiacriticPipe(compare);
  let found = false;
  for (const value of arrayValues) {
    if (removeDiacriticPipe(value)?.includes(normalizedValue)) {
      return found = true;
    }
  }
  return found;
};

export const removeDiacriticPipe = (value: string): string => {
  return value?.normalize('NFD')?.replace(/\p{Diacritic}/gu, '')?.toLocaleLowerCase();
};

export function removeAmpersand(value: string): string {
  //remove ampersun symbol
  return value.replace(/&/g,"");
}

export function changeUrlCharsToHyphen(value: string): string {
  //replace spaces with hyphens
  return value.replace(/&/g,"").replace(/[^\w\d\._~]/g, '-');
}

export function unifyHyphens(value: string): string {
  //unify multiple hyphents to one
  return value.replace(/-+/g, '-').replace(/^-|-$/g, '');
}


/**
 * Make text pretty for url.
 */
export function prettifyTextForUrl(value: string): string {
  if (!value) {
    return value;
  }

  value = removeDiacriticPipe(value);
  value = removeAmpersand(value);
  value = changeUrlCharsToHyphen(value);
  return value.toLocaleLowerCase();
}
